import PropTypes from 'prop-types'
import React from 'react'

import { QuestionOverlayButton } from '..'
import CommentsFeature from '../../../CommentsFeature'
import {
  useOverlayState,
  removeOverlay,
} from '../../../../../firebase/hooks/useOverlays'
import useFeatures from '../../../../hooks/useFeatures'
import { useWebinarColors } from '../../../../../Designs/blocs/useWebinarColors'
import { getRole } from '../../../../../global/blocs/roomInfo'
import { useConnectInfoQuery } from '../../../../../global/blocs/useConnectInfo'
import { isLightColor } from '../../../../utils'

const QuestionsPane = (props) => {
  const {
    unreadQuestionsIdList,
    commonCommentsProps, // TODO: this is object now with bunch of props it needs to be spread
  } = props

  const overlay = useOverlayState()
  const webinarColors = useWebinarColors()
  const { data: connectInfo } = useConnectInfoQuery()
  const { HasWebinarGroupedQuestionsEnabled } = useFeatures()

  const handleDeleteCommentClick = (commentId) => {
    if (overlay?.type === 'question' && overlay?.data.id === commentId) {
      removeOverlay()
    }
  }

  const renderQuestionOverlayButton = (question) => (
    <QuestionOverlayButton question={question} />
  )

  return (
    <div className="comments-wrapper comments-type-question">
      <CommentsFeature
        {...commonCommentsProps}
        styles={{
          inputStyle: {
            color: webinarColors.tabs.contrast.color,
            backgroundColor: `rgba(0, 0, 0, ${
              isLightColor(webinarColors.sidebar.color) ? 0.05 : 0.15
            })`,
          },
          buttonStyle: { backgroundColor: webinarColors.accent.color },
          secondaryButtonStyle: {
            backgroundColor: `rgba(255, 255, 255, ${
              isLightColor(webinarColors.sidebar.color) ? 0.4 : 0.05
            })`,
            color: webinarColors.accent.color,
          },
          singleCommentStyles: {
            readCommentStyle: {
              backgroundColor: webinarColors.tabs.color,
            },
            unreadCommentStyle: {
              borderColor: webinarColors.accent.color,
              backgroundColor: webinarColors.tabs.color,
            },
          },
        }}
        namespace="webinar-sidebar-questions"
        commentType="question"
        canPost={false}
        doNotFetchQuestions={getRole() === 'audience'}
        unreadIdsList={unreadQuestionsIdList}
        onDeleteCommentClick={handleDeleteCommentClick}
        extraListButtons={
          connectInfo?.streaming_method === 'hardware'
            ? undefined
            : (question) => renderQuestionOverlayButton(question)
        }
        isGroupedByStatus={HasWebinarGroupedQuestionsEnabled}
      />
    </div>
  )
}

QuestionsPane.propTypes = {
  unreadQuestionsIdList: PropTypes.object,
  isInGearMode: PropTypes.bool,
  commonCommentsProps: PropTypes.object,
}

export default QuestionsPane
